
export type UpdateUserProfileBodySocialLinks = {
  github?: string;
  linkedin?: string;
  twitter?: string;
};
